import { NgModule } from "@angular/core";
import { PreloadAllModules, RouterModule, Routes } from "@angular/router";
import {
  canActivate,
  redirectUnauthorizedTo,
  redirectLoggedInTo,
} from "@angular/fire/compat/auth-guard";

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(["login"]);
const redirectLoggedInToApp = () => redirectLoggedInTo([""]);

export const routes: Routes = [
  {
    path: "login",
    pathMatch: "full",
    loadChildren: () =>
      import("./pages/login/login.module").then((m) => m.LoginPageModule),
    ...canActivate(redirectLoggedInToApp),
  },
  {
    path: "",
    loadChildren: () =>
      import("./layouts/home-layout/home-layout-routing.module").then(
        (m) => m.HomeLayoutRoutingModule,
      ),
    ...canActivate(redirectUnauthorizedToLogin),
  },
  {
    path: "tutorial",
    loadChildren: () =>
      import("./pages/tutorial/tutorial.module").then(
        (m) => m.TutorialPageModule,
      ),
    ...canActivate(redirectUnauthorizedToLogin),
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      bindToComponentInputs: true,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
  static AngularFireModule: any;
}
